import { render, staticRenderFns } from "./SeriesSort.vue?vue&type=template&id=71605913&"
import script from "./SeriesSort.vue?vue&type=script&lang=js&"
export * from "./SeriesSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports